module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle2"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ch_05"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ARRY")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ENSON")])])])]), _c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', {
    attrs: {
      "href": "#/footnote#footnote5",
      "id": "fn5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("O ME THE MOST IMPORTANT CAR RIDE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OHN")]), _vm._v(" L"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ENNON AND THE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EATLES EVER MADE WAS FROM THE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LAZA")]), _vm._v(" H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OTEL ON THEIR WAY TO THEIR FIRST APPEARANCE ON THE")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("D")]), _vm._v(" S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ULLIVAN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HOW")])]), _vm._v(" "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IN")]), _vm._v(" N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ORK")]), _vm._v(" C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ITY ON")]), _vm._v(" F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EBRUARY 9, 1964.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It started at breakfast time. My room was just down the hall, and I was having breakfast with the four of them in their suite at the Plaza. No one seemed to be eating much. Everything was relatively calm. They were all talking about the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ed Sullivan Show")]), _vm._v(" and what they were going to sing and John said something about just going with the most popular songs.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Outside in the street there was chaos. Police were wrestling with little girls who were climbing up back stairways or passing themselves off as hotel guests. A few got up but were stopped outside the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Back in my room about 1:30 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("PM")]), _vm._v(" with cameras ready—I always keep my cameras ready on a news story and this was a big news story. I was on the bed as I thought they were going to the theater a bit later. There was a bang on my door. John came in and said they were going now and for me to come with them and stay as close as I could or the police would cut me off. Right enough, there was pandemonium trying to get to the car. Downstairs, a policeman tried to stop me from getting into their limo and to his credit John said, “If Harry doesn’t go, I don’t go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Paul, George, Ringo and I got in first and John followed. They were too close for me to take their photo inside the limo (it was not a stretch limo like we have today). They all leaned over and put their heads down so I could get a picture of the fans chasing after us as we drove off. John and I were on the jump seats and in the front were the driver and Mal Evans. It all happened in a matter of seconds. While I was taking the picture from inside the car, John held my camera bag because we were so crammed into such a small space.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "24.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Photograph © Harry Benson 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When we got to the CBS studio, it was the same chaos again. I jumped out first and John kept me next to him because the studio door opened and slammed shut like an elastic band.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I sat around with John drinking Coca-Colas waiting for the show to start. We never went back to the hotel after the rehearsal—it would have been too hectic. And when they went on live television, as everyone knows, they were sensational.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Back in the hotel we had dinner in their suite. It was very quiet as they had turned off the phone in the room. They all seemed relieved that it had gone so well.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After George, Paul and Ringo went to bed, John and I stayed up drinking whiskey and talking for another hour, talking basically about nothing—our childhood and things like that. John said he had been to Glasgow, where I am from, and had seen the same faces he saw in Liverpool. I asked him if he would ever go back and live in Liverpool and he said no. John talked a bit about America and said he found the American press easier than the British press. Still wearing his tie, he had taken off his jacket and shoes. They all complained that the shoes were uncomfortable. The telephone messages, which had been held at the front desk, were sent up and John sat reading them. The congratulations had come in from everywhere and everyone—from senators who wanted to bring their children to meet the Beatles to other artists saying they were a smash.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As the next day would be busy with so many people wanting interviews, I said good night and went to my room. It had been an historic day.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Years later, I met Yoko Ono. I had heard a lot of stories about her, but after meeting her it was quite easy to see why John had loved her. Intelligent, funny, perceptive, with good manners, I think she was the mirror image of John’s best qualities. Although I never photographed John after 1966, I miss him.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1458bbfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch05.vue
// module id = 84
// module chunks = 0